import "../src/login.css";
import { useState, useContext } from "react";
import Karriere from './components/karriere/karriere';

import logo from "../src/img/procuratio_logo.png";

import { DataContext } from "./context/DataContext";

export default function Login() {

  const {
    appLoggedIn,
    appLoggedInChange,
    appShowToastChange,
    appToastColorChange,
    appToastMsgChange,
    appTokenChange,
    appLdapUsername,
    appLdapUsernameChange
    
} = useContext(DataContext);

  const [user, setUser] = useState();
  const [pswd, setPswd] = useState();
  const [showCrew, setShowCrew] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = await loginUser({
      user,
      pswd,
    });
  };

  async function loginUser(credentials) {
    var myHeaders = new Headers();

    var formdata = new FormData();
    formdata.append("user", credentials.user);
    appLdapUsernameChange(credentials.user)
    formdata.append("pswd", credentials.pswd);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      credentials: "same-origin",
    };

    fetch("https://intranet-backend.procuratio.com/login.php", requestOptions)
      //   .then(response => response.text())
      //.then(response=> setTokenStatus(response.status))
      //.then(response=> setTokenJWT(response.text()))
      //.then(response=> console.log("json",response.json()))
      .then(function (response) {
        let responseCopy = response.clone();
        if(responseCopy.status==200){
          
          responseCopy.json().then((data) => {
            localStorage.setItem("prc_ldap_username", data["ldap_username"]);
          });
          responseCopy = response.clone();
          responseCopy.json().then((data) => {
            localStorage.setItem("prc_ldap_first_name", data["ldap_first_name"]);
          });
  
          responseCopy = response.clone();
          responseCopy.json().then((data) => {
            localStorage.setItem("prc_ldap_last_name", data["ldap_last_name"]);
          });
          responseCopy = response.clone();
          responseCopy.json().then(async (data) => {
            await appTokenChange(data["token"]);
            localStorage.setItem("prc_token", data["token"]);
          });
          appLoggedInChange(true)
        }
        else {

          appLoggedInChange(false)
          alert('Login nicht erfolgreich. Wenn Sie Hilfe benötigen wenden Sie sich bitte an den Support')
        }       
      })

      .catch((error) => console.log("error", error));
  }

  return (
    
    <>
      <div
        id="content"
        style={{
          height: "100vh",
          borderRadius: "0 0 0 0",
          backgroundImage:
            "url('https://intranet-backend.procuratio.com/img/bg_pcr.jpg')",
          backgroundSize: "cover",
          backgroundrepeat: "no-repeat",
        }}
      >
        
        { !showCrew ?
        <><div id="loginBox">
          <div id="logo">
            <img src={logo} alt="logo" style={{ width: "200px" }} />
          </div>

          <form onSubmit={handleSubmit}>
            <div className="userdata">
              <input
                type="text"
                name="user"
                placeholder="Benutzername"
                onChange={(e) => setUser(e.target.value)}
              />
            </div>
            <div className="userdata">
              <input
                type="password"
                name="pswd"
                placeholder="Passwort"
                onChange={(e) => setPswd(e.target.value)}
              />
            </div>

            <div className="userdata">
              <button name="submit" value="Anmelden">
                Anmelden
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <span id="logo">
                Bei Problemen mit Ihrem Login wenden Sie sich bitte an den{" "}
                <a
                  style={{ textDecoration: "none", paddingLeft: "5px" }}
                  href="mailto:support@procuratio.com"
                >
                  Support
                </a>
                .
              </span>
              <p style= {{ marginTop: '0' , fontSize: '0.8em' }} >
                Version 1.03.006.5132
              </p>
            </div>
          </form>

        </div>
        <div id="crewBox" style={{cursor: 'pointer'}}><span onClick={() => setShowCrew(true)}>Noch kein Mitarbeiter? Bewerben Sie sich jetzt!</span></div></>
        :
        <Karriere setShowCrew={setShowCrew}/>

        }

      </div>
    </>
  );
}
